import common from "../common";
import Scene from "./Scene";
import Button from "../ui/Button";
import TextInput from "../ui/TextInput";
import TextArea from "../ui/TextArea";
import DropDownInput from "../ui/DropDownInput";
import RadioButton from "../ui/RadioButton";
import CheckboxButton from "../ui/CheckboxButton";

export default class QuestionScene extends Scene 
{
    constructor(questionData, backDirection)
    {
        super('question');

        this.questionData = questionData;
        this.backDirection = backDirection;
        this.panel = null;

        this.inputs = [];
        this.validationMessage = null;

        this.videoPlayer;
    }

    init()
    {
        super.init();

        this.addPanel();

        console.log(this.questionData);

        this.addTopLogo();

        for(var i in this.questionData.fields)
        {
            var fInputs = [];
            var f = this.questionData.fields[i];

            if(f.idFromPreviousAnswer)
            {
                f.id = common.response[f.idFromPreviousAnswer];
            }

            var responseId = f.responseId || f.id;

            if(f.type != 'checkbox' && f.type != 'copy' && f.type != 'video')
            {
                var copy = common.config.strings['question_' + f.id][common.country].replace('A World United', '<strong>A World United</strong>');
                var qTitle = $('<div class="p3-panelItemFormTitle p3-boldText">' + copy + '</div>');
                this.panelInner.append(qTitle);
            }
    
            var aHolder = $('<div class="p3-panelItem"></div>');
            this.panelInner.append(aHolder);

            var css = {position:'relative', float:'left', width:'100%'};
            var attributes = {};

            if(common.response[responseId] != undefined)
            {
                attributes.value = common.response[responseId];
            }
    
            if(f.maxLength)
            {
                attributes.size = f.maxLength;
            }
    
            if(f.type == 'text' || 
               f.type == 'email' ||
               f.type == 'phone')
            {
                var fieldCss = {};

                if(f.type == 'phone')
                {
                    attributes.type = 'integer';
                }
                if(f.type == 'email')
                {
                    attributes.type = 'email';
                }
                if(f.type == 'phone')
                {
                    var fieldHolder = $('<div class="p3-textField"></div>');
                    aHolder.append(fieldHolder);
                    aHolder = fieldHolder;
                    var code = common.config.areacodes[common.response.country];
                    css.width = 'calc(100% - ' + Math.max(4, (code.length * 3)) + 'vh)';
                    fieldCss.border = 'none';
                    aHolder.append('<div style="position:relative; float:left; margin-left:0.5vh; margin-right:0.5vh; margin-top:1vh">' + code + '</div>');
                }
    
                fInputs.push(new TextInput(f.id, f.id, attributes, css, fieldCss));
            
                if(f.align)
                {
                    fInputs[0].formElement.css('textAlign', f.align);
                }
            }
            else if(f.type == 'date' || f.type == 'year')
            {
                delete css.width;
                var options;

                var existingValue = common.response[responseId];

                if(f.type == 'date')
                {
                    if(existingValue)
                    {
                        existingValue = existingValue.split('-');
                        existingValue.reverse();
                    }

                    options = [];
                    for(var i = 1; i <= 31; i++)
                    {
                        options.push({name:i, value:this.padNumber(i)});
                    }
                    var day = new DropDownInput(common.config.strings.day[common.country], common.config.strings.day[common.country], options, existingValue ? existingValue[0] : null, css);
                    day.htmlElement.addClass('p3-date-dropDown-day');
                    fInputs.push(day)
                    
                    options = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
                    for(var i = 0; i < options.length; i++)
                    {
                        options[i] = {name:common.config.strings[options[i]][common.country], value:this.padNumber(i+1)};
                    }
                    var month = new DropDownInput(common.config.strings.month[common.country], common.config.strings.month[common.country], options, existingValue ? existingValue[1] : null, css);
                    month.htmlElement.addClass('p3-date-dropDown-month');
                    fInputs.push(month);

                    if(existingValue)
                        existingValue = existingValue[2];
                }
                options = [];
                var thisYear = new Date().getFullYear();
                for(var i = thisYear-98; i <= thisYear; i++)
                {
                    options.push({name:i, value:i});
                }
                var year = new DropDownInput(common.config.strings.year[common.country], common.config.strings.year[common.country], options, existingValue ? existingValue : new Date().getFullYear(), css);
                fInputs.push(year);
                if(fInputs.length > 1)
                {
                    year.htmlElement.addClass('p3-date-dropDown-year');
                }
            }
            else if(f.type == 'dropdown')
            {
                fInputs.push(new DropDownInput(f.id, f.id, f.options, common.response[responseId], css));
            }
            else if(f.type == 'radio')
            {
                delete css.width;
                var count = 0;
                for(var i in f.options)
                {
                    fInputs.push(new RadioButton(common.config.strings[f.options[i].name][common.country], 'option-' + count, 'radio-options', f.options[i].value, f.options[i].value == common.response[responseId], css) )
                    count++;
                }
            }
            else if(f.type == 'field')
            {
                fInputs.push(new TextArea(f.id, f.id, attributes, css));
            }
            else if(f.type == 'checkbox')
            {
                fInputs.push(new CheckboxButton(common.config.strings['question_' + f.id][common.country], f.id, f.id, common.response[responseId] == true, f.required));
                aHolder.css('textAlign', 'left');
            }
            else if(f.type == 'copy')
            {
                var copy = common.config.strings['question_' + f.id][common.country].replace('A World United', '<strong>A World United</strong>');
                var div = $('<div class="p3-questionCopy">' + copy + '</div>');
                aHolder.append(div);
                if(f.fontSize)
                {
                    div.addClass('p3-' + f.fontSize + 'Text');
                }
            }
            else if(f.type == 'video')
            {
                var timestamp = Date.now();
                var videoUrl = common.config.settings.videoLinks[f.id][$(window).height() > $(window).width() ? 'mobile' : 'desktop'][common.country];
                var format = 'mp4';
                //Firefox
                if (typeof InstallTrigger !== 'undefined')
                {
                    format = 'webm';
                }
                var div = $('<video-js id="videoPlayer' + timestamp + '" class="video-js" width="720" height="480" style="width:100%;" controls autoplay><source src="' + videoUrl + '.' + format + '" type="video/' + format + '" /></video-js>');
                aHolder.append(div);

                this.videoPlayer = videojs("videoPlayer" + timestamp, {
                    fluid: true
                });
            }
    
            for(var i in fInputs)
            {
                aHolder.append(fInputs[i].htmlElement);
            }

            this.inputs.push(fInputs);
        }

        this.validationMessage = $('<div class="p3-panelItem p3-validationMessage"></div>');
        this.panelInner.append(this.validationMessage);

        var submit = this.addSubmitButton(common.config.strings.next[common.country], true);
        this.signalListeners.push(submit.signals.up.add(this.onSubmit.bind(this)));
        this.buttons['submit'] = submit;

        if(this.videoPlayer)
        {
            if(!common.saveData.isVideoPlayed(f.id))
            {
                submit.htmlElement.hide();
            }
            if(!this.backDirection)
            {
                this.videoPlayer.on("play", () => {
                    this.videoPlayer.requestFullscreen();
                })
            }
            this.videoPlayer.on("ended", () => {
                submit.htmlElement.show();
                common.saveData.markVideoAsPlayed(f.id);
                this.onSubmit();
            });
            common.videoPlaying = true;
            if(!common.saveData.muted)
            {
                common.soundManager.mute();
            }
        }

        this.panelForm.submit((e) => {
            e.preventDefault();
            document.activeElement.blur();
            this.onSubmit();
        });

        var leftFooter = $('<div class="p3-panelFooterLeft"></div>')
        this.panelFooter.append(leftFooter);
        var rightFooter = $('<div class="p3-panelFooterRight"></div>')
        this.panelFooter.append(rightFooter);

        var back = this.addSecondaryButton(common.config.strings.back[common.country]);
        this.signalListeners.push(back.signals.up.add(this.onBack.bind(this)));
        this.buttons['back'] = back;
        leftFooter.append(back.htmlElement);

        rightFooter.append(submit.htmlElement);

    }

    postInit()
    {
        super.postInit();
    }

    padNumber(number)
    {
        number = String(number);
        if(number.length < 2)
            return '0' + number;
        return number;
    }

    validate()
    {
        for(var i in this.questionData.fields)
        {
            if(this.questionData.fields[i].required == false)
                continue;

            var type = this.questionData.fields[i].type;
            if(type == 'text' || type == 'email' ||
               type == 'phone' || type == 'field')
            {
                console.log(this.inputs[i][0].currentValue);
                if(this.inputs[i][0].currentValue == undefined || this.inputs[i][0].currentValue == "")
                {
                    return common.config.strings.validation_field_blank[common.country];
                }
            }
            if(type == 'phone')
            {
                if(isNaN(Number(this.inputs[i][0].currentValue)))
                {
                    return common.config.strings.validation_phone[common.country];
                }
            }
            if(type == 'email')
            {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(!re.test(String(this.inputs[i][0].currentValue).toLowerCase()))
                {
                    return common.config.strings.validation_email[common.country];
                }
            }
            if(type == 'radio')
            {
                if($("input[name='radio-options']:checked").val() == undefined)
                {
                    return common.config.strings.validation_radio[common.country];
                }
            }
            if(type == 'date' && this.questionData.fields[i].minAge)
            {
                var birthday = new Date(this.inputs[i][2].currentValue + '-' + this.inputs[i][1].currentValue + '-' + this.inputs[i][0].currentValue);
                var ageDifMs = Date.now() - birthday.getTime();
                var ageDate = new Date(ageDifMs); // miliseconds from epoch
                
                var age = Math.abs(ageDate.getUTCFullYear() - 1970);

                if(age < this.questionData.fields[i].minAge)
                {
                    return common.config.strings.validation_age[common.country];
                }
            }
            if(type == 'checkbox' && this.inputs[i][0].required && !this.inputs[i][0].isChecked())
            {
                return common.config.strings.validation_terms[common.country];
            }
        }
        return 'accepted';
    }

    save()
    {
        for(var i in this.questionData.fields)
        {
            var f = this.questionData.fields[i];

            var responseId = f.responseId || f.id;

            if(f.type == 'date')
            {
                common.response[responseId] = "";
                for(var j = this.inputs[i].length-1; j >= 0; j--)
                {
                    common.response[responseId] += (j < this.inputs[i].length-1 ? '-' : '') + (this.inputs[i][j].currentValue != undefined ? this.inputs[i][j].currentValue : '');
                }
            }
            else if(f.type == 'radio')
            {
                common.response[responseId] = $("input[name='radio-options']:checked").val();
            }
            else if(f.type == 'checkbox')
            {
                common.response[responseId] = this.inputs[i][0].isChecked() ? '1' : '0';
            }
            else if(f.type == 'field')
            {
                common.response[responseId] = this.inputs[i][0].currentValue || "";
                for(var j = 0; j <= Math.max(0, 3 - common.response[responseId].length); j++)
                {
                    console.log('space');
                    common.response[responseId] += " ";
                }
            }
            else if(f.type == 'hidden')
            {
                if(f.value != null)
                {
                    common.response[responseId] = f.value;
                }
            }
            else if(f.type != "copy" && f.type != "video")
            {
                common.response[responseId] = "";

                for(var j in this.inputs[i])
                {
                    common.response[responseId] += (j > 0 ? '-' : '') + (this.inputs[i][j].currentValue != undefined ? this.inputs[i][j].currentValue : '');
                }
            }
        }
    }

    onBack()
    {
        if(this.videoPlayer)
        {
            common.videoPlaying = false;
            if(!common.saveData.muted)
            {
                common.soundManager.unmute();
            }
        }

        if(this.validate())
            this.save();

        this.animatePanelOut(() => {
            this.signals.previous.dispatch();
        });
    }

    onSubmit()
    {
        if(this.videoPlayer)
        {
            common.videoPlaying = false;
            if(!common.saveData.muted)
            {
                common.soundManager.unmute();
            }
        }

        this.validationMessage.empty();
        var result = this.validate();
        if(result != 'accepted')
        {
            this.validationMessage.append('<img src="'+ common.baseUrl + '/assets/images/ui_icon_error.png" style="height:3vh; vertical-align:middle;"/> ' + result);
            return;
        }

        this.save();

        var boardType = this.questionData.boardType;
        var id = '';

        console.log(boardType);

        var boardValueField = 0;
        if(this.questionData.fields.length > 0)
        {
            for(var i = 0; i < this.questionData.fields.length; i++)
            {
                if(this.questionData.fields[i].boardValue)
                    boardValueField = i;
            }
        }

        var field = this.questionData.fields[boardValueField];

        if(field.type == 'dropdown' && (boardType == 'image' || boardType == 'player'))
        {
            for(var i in field.options)
            {
                if(field.options[i].value == this.inputs[boardValueField][0].currentValue)
                {
                    if(boardType == 'player')
                    {
                        id = field.options[i].value;
                    }
                    else
                    {
                        id = field.options[i].boardImage;
                    }
                }
            }
        }
        else if(boardType == 'text')
        {
            if(this.questionData.textPrefix)
            {
                id = common.config.strings[this.questionData.textPrefix][common.country] + '\n'; 
            }
            id += common.response[field.id];
        }
        else if(boardType == 'image')
        {
            id = this.questionData.boardImage;
        }

        /*
        else if(boardType == 'years')
        {
            var years = new Date().getFullYear() - this.inputs[boardValueField][0].currentValue;
            if(years > 1 || years == 0)
                id = common.config.strings.board_fan_for_years[common.country].replace('**', years);
            else
                id = common.config.strings.board_fan_for_1_year[common.country];
        }*/

        this.animatePanelOut(() => {
            this.signals.next.dispatch(boardType, id);
        });
    }
}